"use client";

import { useEffect, useRef } from "react";
import { createClient } from "@/lib/supabase-browser";
import { api } from "@/lib/api-client";
import { getFingerprint } from "@/lib/fingerprint";

const STORAGE_KEY = "rekkd_fp_sent";

/**
 * Silently collects and submits a device fingerprint once per browser session.
 * Only fires for authenticated users. Renders nothing.
 */
export default function FingerprintCollector() {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    sent.current = true;

    const supabase = createClient();
    supabase.auth.getUser().then(({ data }) => {
      if (!data.user) return;

      getFingerprint()
        .then((fp) => api.post("/api/fingerprint", { fingerprint: fp }))
        .then(() => sessionStorage.setItem(STORAGE_KEY, "1"))
        .catch(() => {
          // Fingerprinting is best-effort; don't block the user
        });
    });
  }, []);

  return null;
}
